import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { Quinzena } from 'pages/financeiro/reembolso/gerar-reembolso/types';

type GerarReembolsoQuinzenaAutoComplete = Pick<CissAutoCompleteProps, 'onChange' | 'value' | 'error' | 'disabled' | 'sx'>;

const quinzena: Quinzena[] = [
    { idQuinzena: 1, dsQuinzena: '1ª quinzena' },
    { idQuinzena: 2, dsQuinzena: '2ª quinzena' },
];

export function GerarReembolsoQuinzenaAutoComplete({ onChange, value, error, disabled, sx }: GerarReembolsoQuinzenaAutoComplete) {
    return (
        <CissAutoComplete
            sx={sx}
            value={value}
            error={error}
            disabled={disabled}
            onChange={onChange}
            multiple={false}
            size="small"
            label="Quinzena"
            selectedStringTemplate="{dsQuinzena}"
            optionStringTemplate="{dsQuinzena}"
            isOptionEqualToValue={(option: Quinzena, value: Quinzena) => option.idQuinzena === value.idQuinzena}
            options={quinzena}
        />
    );
}
